import { CopyIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useClipboard } from "@vega-core/hooks/useClipboard";
import { m } from "@vega-core/paraglide/messages";

import { EmailTextButton } from "../../Buttons/EmailTextButton/EmailTextButton";
import { ModalHeader } from "../ModalHeader/ModalHeader";
import { VegaDialog } from "../VegaDialog/VegaDialog";

type Props = {
  open: boolean;
  onClose: VoidFunction;
  email: string;
};

export const EmailContactModal = ({ open, onClose, email }: Props) => {
  const { copy } = useClipboard({ name: m.form_email(), withToast: true });

  return (
    <VegaDialog
      data-testid="email-contact-dialog"
      onClose={onClose}
      open={open}
    >
      <div className="space-y-4">
        <ModalHeader title={m.titles_contactUs()} />

        <div className="text-text/secondary body-base-regular">
          {m.contact_message()}
          <EmailTextButton email={email} />
        </div>

        <div className="flex justify-end">
          <ThemedButton
            className="min-w-13"
            dataTestId="copy-button"
            icon={<CopyIcon />}
            onClick={() => copy(email)}
            variant="secondary"
          >
            {m.btn_copyNamed({ name: m.form_email() })}
          </ThemedButton>
        </div>
      </div>
    </VegaDialog>
  );
};
